import Immutable from 'immutable';

import * as BetStatus from 'constants/BetStatus';
import * as StakeStatus from 'constants/StakeStatus';

function validate(betHistory) {
    const keys = betHistory.keySeq().toArray();

    for (let i = 0; i < keys.length; i++) {
        const bh = betHistory.get(keys[i]);

        if (bh.get('stakeId') === undefined || bh.get('betType') === undefined ||
            bh.get('amount') === undefined || bh.get('odd') === undefined ||
            bh.get('possibleWinAmount') === undefined) {
            return false;
        }

        const betStatus = bh.get('betStatus');
        if (betStatus === undefined || (betStatus !== BetStatus.INIT && betStatus !== BetStatus.REJECTED &&
            betStatus !== BetStatus.CONFIRMED && betStatus !== BetStatus.CALCULATED &&
            betStatus !== BetStatus.CASHOUT && betStatus !== BetStatus.BET_PAY_REQUEST &&
            betStatus !== BetStatus.IN_DELAY && betStatus !== BetStatus.STAKE_REQUEST &&
            betStatus !== BetStatus.CONFIRM_AWAIT)) {
            return false;
        }

        const stakeStatus = bh.get('stakeStatus');
        if (stakeStatus === undefined || (stakeStatus !== StakeStatus.ACTIVE && stakeStatus !== StakeStatus.WON &&
            stakeStatus !== StakeStatus.LOST)) {
            return false;
        }

        const betSlips = bh.get('betSlips');
        if (betSlips === undefined) {
            return false;
        }

        const betSlipKeys = betSlips.keySeq().toArray();

        for (let j = 0; j < betSlipKeys.length; j++) {
            const bs = betSlips.get(betSlipKeys[j]);

            const rate = bs.get('rate');
            const outcome = bs.get('outcome');
            const match = bs.get('match');

            if (rate === undefined || outcome === undefined || match === undefined) {
                return false;
            }

            if (rate.get('id') === undefined || rate.get('outcomeId') === undefined ||
                rate.get('type') === undefined || rate.get('value') === undefined) {
                return false;
            }

            if (outcome.get('name') === undefined) {
                return false;
            }

            if (match.get('timeAndZone') === undefined || match.get('name') === undefined) {
                return false;
            }
        }
    }

    return true;
}

export default function (data) {
    const gamblerId = data.Id;

    let betHistory;
    let bettingMode;
    let userGridSelection;
    let betSlips;
    let betTypes;
    let betTypeIndex;
    let couponState;
    let betSlipAmounts;

    const betHistoryJson = localStorage.getItem(gamblerId + '_betHistory');
    if (betHistoryJson !== null && betHistoryJson !== '' && betHistoryJson !== '{}') {
        betHistory = Immutable.fromJS(JSON.parse(betHistoryJson));

        const isValid = validate(betHistory);
        if (!isValid) {
            localStorage.removeItem(gamblerId + '_betHistory');
        }
    }

    const bettingModeJson = localStorage.getItem(gamblerId + '_bettingMode');
    if (bettingModeJson !== null && bettingModeJson !== '' && bettingModeJson !== '{}') {
        bettingMode = Immutable.fromJS(JSON.parse(bettingModeJson));
    }

    const userSelectionsJson = localStorage.getItem(gamblerId + '_userSelections');
    if (userSelectionsJson !== null && userSelectionsJson !== '' && userSelectionsJson !== '{}') {
        userGridSelection = Immutable.fromJS(JSON.parse(userSelectionsJson));
    }

    const betSlipsJson = localStorage.getItem(gamblerId + '_betSlips');
    const betTypesJson = localStorage.getItem(gamblerId + '_betTypes');
    const betSlipAmountsJson = localStorage.getItem(gamblerId + '_betSlipAmounts');
    betTypeIndex = localStorage.getItem(gamblerId + '_betTypeIndex');
    couponState = localStorage.getItem(gamblerId + '_couponState');

    if ((betSlipsJson !== null && betSlipsJson !== '' && betSlipsJson !== '{}') &&
        (betTypesJson !== null && betTypesJson !== '' && betTypesJson !== '{}') &&
        (betSlipAmountsJson !== null && betSlipAmountsJson !== '' && betSlipAmountsJson !== '{}') &&
        (betTypeIndex !== null && betTypeIndex !== '')) {
        betSlips = Immutable.fromJS(JSON.parse(betSlipsJson));
        betTypes = JSON.parse(betTypesJson);
        betSlipAmounts = JSON.parse(betSlipAmountsJson);
    }

    return {
        betHistory,
        bettingMode,
        userGridSelection,
        betSlips,
        betTypes,
        betTypeIndex: Number(betTypeIndex),
        couponState: Number(couponState),
        betSlipAmounts
    };
}


// WEBPACK FOOTER //
// ./js/shared/Storage.js